module.exports = __webpack_public_path__ + "img/logo_fluxsolar_blanco.0ef9cbb2.png";